import { useMemo } from 'react';

import { UnifiedDialogEntry } from '../../../../types';

export const useSortedEntries = (entries: UnifiedDialogEntry[]): UnifiedDialogEntry[] => {
  return useMemo(() => {
    return [...entries].sort((a, b) => {
      const timeDiff = new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
      if (timeDiff !== 0) return timeDiff;

      // Secondary sort: call_header before call_segment when timestamps match
      if (a.entry_type === 'call_header' && b.entry_type === 'call_segment') return -1;
      if (a.entry_type === 'call_segment' && b.entry_type === 'call_header') return 1;

      // Tertiary sort: for call_segments with same created_at, sort by start_time
      if (a.entry_type === 'call_segment' && b.entry_type === 'call_segment') {
        const aStartTime = a.start_time ?? 0;
        const bStartTime = b.start_time ?? 0;
        return aStartTime - bStartTime;
      }

      return 0;
    });
  }, [entries]);
};
